// Mock data for LFXPro Lights website

export const products = [
  {
    id: 1,
    name: "Moving Head Beam",
    category: "moving-head-beam",
    description: "Precision-engineered moving head beam fixtures delivering powerful, concentrated light beams with exceptional speed and accuracy. Perfect for creating dynamic aerial effects in concerts and large-scale events.",
    image: "https://images.unsplash.com/photo-1758706552632-64ab529c2631",
    features: ["High-speed pan/tilt", "Intense beam output", "DMX512 control", "German engineering"],
    applications: ["Concerts", "Festivals", "Arena shows"]
  },
  {
    id: 2,
    name: "Wash Lights",
    category: "wash",
    description: "Professional-grade wash lighting systems providing smooth, even color coverage across large areas. Engineered for superior color mixing and seamless transitions.",
    image: "https://images.unsplash.com/photo-1762028895256-1256ffcbaf16",
    features: ["RGBW color mixing", "Wide beam angle", "Silent operation", "Energy efficient"],
    applications: ["Stage lighting", "Architectural", "TV studios"]
  },
  {
    id: 3,
    name: "BSW (Beam-Spot-Wash)",
    category: "bsw",
    description: "Revolutionary 3-in-1 lighting solution combining beam, spot, and wash capabilities in a single fixture. Ultimate versatility for any professional application.",
    image: "https://images.unsplash.com/photo-1763560595910-0141a43e06ef",
    features: ["3-in-1 functionality", "Motorized zoom", "Prism effects", "Rotating gobos"],
    applications: ["Multi-purpose venues", "Touring shows", "Premium installations"]
  },
  {
    id: 4,
    name: "Professional Lasers",
    category: "lasers",
    description: "State-of-the-art laser systems delivering stunning visual effects with precise control and safety features. Engineered in Germany for uncompromising performance.",
    image: "https://images.unsplash.com/photo-1766823120507-cde723995efe",
    features: ["RGB full-color", "ILDA compatible", "Safety certified", "Precision scanning"],
    applications: ["Clubs", "Festivals", "Architectural projection"]
  },
  {
    id: 5,
    name: "Strobe Lights",
    category: "strobe",
    description: "High-powered strobe fixtures creating intense, synchronized flashes. Precision-engineered for maximum impact and reliability in demanding environments.",
    image: "https://images.unsplash.com/photo-1618853802485-be85de3d160f",
    features: ["Variable flash rate", "0-100% dimming", "Synchronized control", "Long lamp life"],
    applications: ["Concerts", "DJ performances", "Special effects"]
  },
  {
    id: 6,
    name: "PAR LED Lights",
    category: "par-led",
    description: "Advanced LED PAR fixtures offering vibrant colors, exceptional efficiency, and reliable performance. Perfect for both fixed installations and touring applications.",
    image: "https://images.pexels.com/photos/53265/pexels-photo-53265.jpeg",
    features: ["RGBA+UV LEDs", "Wireless DMX ready", "Silent convection cooling", "50,000+ hour lifespan"],
    applications: ["Theaters", "Corporate events", "Fixed installations"]
  },
  {
    id: 7,
    name: "Accessories & SFX",
    category: "accessories",
    description: "Comprehensive range of professional lighting accessories and special effects equipment. From fog machines to lighting controllers, everything you need for a complete setup.",
    image: "https://images.unsplash.com/photo-1678272142451-b0bc2e2e5f54",
    features: ["DMX controllers", "Fog & haze machines", "Truss systems", "Professional cables"],
    applications: ["Complete lighting setups", "Event production", "Permanent installations"]
  }
];

export const galleryImages = [
  {
    id: 1,
    title: "International Music Festival",
    category: "Festival",
    image: "https://images.unsplash.com/photo-1562177274-4d388b519ecf",
    description: "Main stage lighting design for 50,000+ attendees"
  },
  {
    id: 2,
    title: "Arena Concert Tour",
    category: "Concert",
    image: "https://images.unsplash.com/photo-1617339859516-998a15d4ba42",
    description: "Full lighting production for international touring artist"
  },
  {
    id: 3,
    title: "Premium Nightclub Installation",
    category: "Club",
    image: "https://images.unsplash.com/photo-1765278248871-1d574fb1392d",
    description: "360° immersive lighting installation"
  },
  {
    id: 4,
    title: "Stadium Show",
    category: "Concert",
    image: "https://images.pexels.com/photos/167605/pexels-photo-167605.jpeg",
    description: "Large-scale concert lighting with synchronized effects"
  },
  {
    id: 5,
    title: "Theater Production",
    category: "Theater",
    image: "https://images.unsplash.com/photo-1576514129883-2f1d47a65da6",
    description: "Sophisticated lighting design for Broadway production"
  },
  {
    id: 6,
    title: "Music Festival Main Stage",
    category: "Festival",
    image: "https://images.pexels.com/photos/976862/pexels-photo-976862.jpeg",
    description: "Dynamic lighting for outdoor festival headliner"
  },
  {
    id: 7,
    title: "Architectural Lighting",
    category: "Architecture",
    image: "https://images.unsplash.com/photo-1571440727633-ca6b05da2008",
    description: "Permanent facade lighting for luxury building"
  },
  {
    id: 8,
    title: "Professional Installation",
    category: "Installation",
    image: "https://images.pexels.com/photos/29832605/pexels-photo-29832605.jpeg",
    description: "Custom grid lighting system for premium venue"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marcus Weber",
    role: "Lead Lighting Designer",
    company: "Europa Tour Productions",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
    quote: "LFXPro Lights has transformed our touring productions. The precision and reliability of their equipment are unmatched. We've never experienced a single failure across 120+ shows.",
    rating: 5
  },
  {
    id: 2,
    name: "Sophia Martinez",
    role: "Technical Director",
    company: "Lumina Festival Group",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
    quote: "The beam intensity and color accuracy are phenomenal. LFXPro's German engineering truly delivers on the promise of 'Engineered for Experience.' Our clients are consistently amazed.",
    rating: 5
  },
  {
    id: 3,
    name: "Rajesh Kumar",
    role: "Venue Manager",
    company: "Grand Arena Mumbai",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
    quote: "From installation to daily operation, LFXPro Lights has exceeded every expectation. The support team is exceptional, and the equipment quality is world-class. Worth every rupee.",
    rating: 5
  },
  {
    id: 4,
    name: "Elena Petrova",
    role: "Production Manager",
    company: "Starlight Events",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80",
    quote: "We've equipped three venues with LFXPro systems. The versatility of their BSW series alone has cut our equipment needs by 40%. Exceptional German engineering at its finest.",
    rating: 5
  }
];

export const certifications = [
  {
    id: 1,
    name: "CE Certified",
    description: "European Conformity - Product safety and quality standards",
    icon: "Shield"
  },
  {
    id: 2,
    name: "ISO 9001:2015",
    description: "Quality Management System Certification",
    icon: "Award"
  },
  {
    id: 3,
    name: "RoHS Compliant",
    description: "Restriction of Hazardous Substances - Environmental standards",
    icon: "Leaf"
  },
  {
    id: 4,
    name: "IEC 60598",
    description: "International safety standards for luminaires",
    icon: "CheckCircle"
  },
  {
    id: 5,
    name: "DMX512-A",
    description: "Standard digital communication protocol certification",
    icon: "Radio"
  },
  {
    id: 6,
    name: "IP65 Rated",
    description: "Dust tight and water resistant for outdoor use",
    icon: "Droplets"
  }
];

export const contactInfo = {
  india: {
    title: "Office Location - India",
    address: "A-23, Kamla Nagar",
    city: "Delhi 110007",
    country: "India"
  },
  germany: {
    title: "R&D Centre - Germany",
    address: "Max-Planck-Straße 15",
    city: "85748 Garching bei München",
    country: "Germany"
  },
  email: "lfxprolights@gmail.com",
  phone: "+91 9958461007",
  social: {
    instagram: "https://www.instagram.com/lfxprolights",
    facebook: "https://www.facebook.com/LFXPro-Lights",
    linkedin: "#",
    youtube: "#"
  }
};
